import React from 'react';
import { services } from '../data/mock';
import { Check, ArrowRight } from 'lucide-react';

const Services = ({ onOpenAnamnese }) => {
  const handleServiceClick = (serviceId) => {
    onOpenAnamnese(serviceId);
  };
  return (
    <section id="services" className="section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="hero-medium">Nos Soins</h2>
          <p className="body-large section-intro">
            Des thérapies naturelles pour votre bien-être physique et mental.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={service.id} 
              className="service-card fade-in-up clickable" 
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => handleServiceClick(service.id)}
            >
              <div className="service-image-wrapper">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="service-image"
                  loading="lazy"
                />
                <div className="service-overlay">
                  <div className="service-overlay-content">
                    <ArrowRight size={32} className="service-arrow" />
                    <span className="body-regular">Réserver cette prestation</span>
                  </div>
                </div>
              </div>
              <div className="service-content">
                <div className="service-header-with-price">
                  <h3 className="heading-2">{service.title}</h3>
                  <span className="service-price">{service.price}</span>
                </div>
                <p className="body-regular">{service.description}</p>
                
                {service.reduction && (
                  <div className="service-reduction">
                    <span className="body-small reduction-badge">{service.reduction}</span>
                  </div>
                )}
                
                <div className="service-benefits">
                  {service.benefits.map((benefit, idx) => (
                    <div key={idx} className="benefit-item">
                      <Check size={16} className="benefit-icon" />
                      <span className="body-small">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;